/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/video-analysis-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/video-analysis-api-client";
import type { StationSettingsClientControllerPatchSettingsMutationRequest, StationSettingsClientControllerPatchSettingsMutationResponse, StationSettingsClientControllerPatchSettingsPathParams } from "../models/StationSettingsClientControllerPatchSettings";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { stationSettingsClientControllerPatchSettings } from "../axios/stationSettingsClientControllerPatchSettings";
import { useMutation } from "@tanstack/react-query";

export const stationSettingsClientControllerPatchSettingsMutationKey = () => ["video-analysis-api", { url: '/station-settings/:entityId' }] as const

export type StationSettingsClientControllerPatchSettingsMutationKey = ReturnType<typeof stationSettingsClientControllerPatchSettingsMutationKey>

/**
 * @description Update settings for a specific station (client access)
 * @summary Patch station settings
 * {@link /station-settings/:entityId}
 */
export function useStationSettingsClientControllerPatchSettings<TContext>(options: 
{
  mutation?: UseMutationOptions<StationSettingsClientControllerPatchSettingsMutationResponse, ResponseErrorConfig<Error>, {entityId: StationSettingsClientControllerPatchSettingsPathParams["entityId"], data?: StationSettingsClientControllerPatchSettingsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<StationSettingsClientControllerPatchSettingsMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? stationSettingsClientControllerPatchSettingsMutationKey()

  return useMutation<StationSettingsClientControllerPatchSettingsMutationResponse, ResponseErrorConfig<Error>, {entityId: StationSettingsClientControllerPatchSettingsPathParams["entityId"], data?: StationSettingsClientControllerPatchSettingsMutationRequest}, TContext>({
    mutationFn: async({ entityId, data }) => {
      return stationSettingsClientControllerPatchSettings(entityId, data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}